<template>
  <v-layout column fill-height class="page-wrap">
    <v-flex shrink>
      <!-- 테스크탑 바 -->
      <DesktopBar/>
    </v-flex>
    <v-flex class="grow" style="background-color: #fafafa;">
      <v-container fill-height :style="'max-width:' + $vuetify.breakpoint.thresholds.md + 'px'">
        <v-layout column wrap>
          <v-flex class="shrink text-xs-left">
            <v-layout row wrap>
              <v-flex shrink>
                <h1>
                  <strong>
                    <span class="py-4">고객리뷰 <span class="text-point">{{total}}</span>개</span>
                  </strong>
                </h1>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex shrink v-if="auth.isAuth">
                <v-btn depressed color="primary" @click="writeModal.show = true">리뷰등록</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-divider class="my-3"></v-divider>
          <v-flex>
            <h3 class="font-weight-medium">고객님들의 솔직한 후기가 있는 공간입니다.</h3>
          </v-flex>
          <v-flex class="grow">
            <v-container fill-height :style="'max-width:' + $vuetify.breakpoint.thresholds.md + 'px'">
              <v-layout row wrap class="my-5">
                <v-flex class="px-3 py-2" xs12 sm6 md4 v-if="data.length > 0" v-for="(item, i) in data" :key="i">
                  <v-card
                    class="elevation-5"
                  >
                    <v-card-title
                      class="title"
                      primary-title
                    >
                      <strong>{{getName(item.mb_id, item.mb_name)}}님</strong><v-spacer></v-spacer><v-icon size="24" color="red" v-if="auth.id === item.mb_id" @click="delItem(item.wr_id)">delete</v-icon>
                    </v-card-title>
                    <v-card-text v-html="item.contents" style="min-height: 160px">
                    </v-card-text>
                    <div class="text-xs-center mt-2 mb-3">
                      <v-rating
                        v-model="item.rating"
                        color="yellow darken-3"
                        background-color="grey darken-1"
                        empty-icon="$vuetify.icons.ratingFull"
                        half-increments
                        readonly
                        hover
                      ></v-rating>
                    </div>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-space-between">
                      <v-spacer></v-spacer>
                      <span class="pr-2 grey--text text--lighten-1 font-weight-light body-1"><I>{{item.date.substring(2, 16)}}</I></span>
                    </v-card-actions>
                  </v-card>
                </v-flex>
                <v-flex xs12 shrink class="mt-3">
                  <v-layout class=" justify-center align-center">
                    <v-flex shrink>
                      <v-btn large fab dark color="title_dark1 flex-ie-fix" @click="listUpdate()">
                        <span><v-icon>keyboard_arrow_down</v-icon></span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
    <v-flex class="shrink">
      <!-- 하단내용 -->
      <Footer/>
    </v-flex>
    <!-- 폼 모달 -->
    <v-dialog
      v-model="writeModal.show"
      max-width="360"
    >
      <v-form ref="review_form"  class="row wrap view-form-box" lazy-validation>
        <div class="btn-close" @click="writeModal.show = false"><v-icon>close</v-icon></div>
        <v-flex class="form-title">리뷰등록</v-flex>
        <v-flex class="login-from mt-3">
          <v-flex>
            <v-text-field
              v-model="auth.name"
              label="성함"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-textarea
              v-model="writeModal.contents"
              label="리뷰내용"
              rows="5"
              counter="150"
              :rules="rules.contents"
              box
            ></v-textarea>
          </v-flex>
          <v-flex class="text-xs-center mt-2 mb-3">
            <v-rating
              v-model="writeModal.rating"
              label="리뷰내용"
              color="yellow darken-3"
              background-color="grey darken-1"
              empty-icon="$vuetify.icons.ratingFull"
              half-increments
              hover
            ></v-rating>
          </v-flex>
          <v-flex>
            <v-btn block color="title_dark1" style="height: 46px;"  :loading="writeModal.loading" :disabled="writeModal.loading" @click="submitForm">
              <span style="color:#fff; font-size: 16px;">등록하기</span>
            </v-btn>
          </v-flex>
        </v-flex>
      </v-form>
    </v-dialog>
  </v-layout>
</template>

<script>
import DesktopBar from './layout/DesktopBar'
import Footer from './layout/Footer'

import EventBus from '@/utile/eventBus'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'Review',
  data: () => ({
    writeModal: {
      show: false,
      contents: '',
      rating: 5,
      loading: false
    },
    rules: {
      contents: [
        v => !!v || '내용을 입력해주세요.',
        v => (v && v.length <= 150) || '내용이 너무 많습니다.'
      ]
    },
    data: [],
    offset: 0,
    total: 0
  }),
  computed: {
    ...mapState({
      auth: state => state.auth,
      board: state => state.board,
      config: state => state.config
    })
  },
  mounted () { // 시작
    this.listUpdate()
  },
  methods: { // 메소드
    ...mapActions({
      requestBoardData: 'board/requestBoardData'
    }),
    getName (id, name) {
      if (this.auth.id === id) {
        return name
      } else {
        return name.substring(0, 1) + '*' + name.substring(2)
      }
    },
    delItem (id) {
      this.requestBoardData({ 'type': 'reviewDel', 'wr_id': id }).then((data) => {
        if (data.array.rcode === '1') { // 성공
          EventBus.$emit('alert', '리뷰가 정상적으로 삭제되었습니다.')
          this.offset = 0
          this.data = []
          this.listUpdate()
        } else {
          EventBus.$emit('alert', '삭제에 실패하였습니다.')
        }
      })
    },
    submitForm () {
      if (this.$refs.review_form.validate()) { // 룰에 어긋나지 않는다면
        this.writeModal.loading = true
        this.requestBoardData({ 'type': 'reviewWrite', 'contents': this.writeModal.contents, 'rating': this.writeModal.rating }).then((data) => {
          this.writeModal.loading = false

          if (data.array.rcode === '1') { // 성공
            EventBus.$emit('alert', '리뷰가 정상적으로 등록 되었습니다.')
            this.writeModal.show = false
            // 초기화
            this.writeModal.contents = ''
            this.writeModal.rating = 5
            this.offset = 0
            this.data = []
            this.listUpdate()
          } else if (data.array.rcode === '0') { // 에러
            EventBus.$emit('alert', data.array.msg)
          }
        }).catch((err) => {
          console.log(err)
          this.writeModal.loading = false
        })
      }
    },
    // 리스트 업데이트
    listUpdate () {
      this.requestBoardData({ 'type': 'reviewList', 'offset': this.offset }).then((data) => {
        if (data.array.length > 0) {
          this.offset = this.offset + data.array.length
          this.total = data.totcount
          const _this = this
          data.array.forEach(function (value) {
            _this.data.push(value)
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  components: {
    DesktopBar,
    Footer
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Review.vue